import { T } from '@design/index';

/**
 * The two numbers that actually send an ambulance, one tap away.
 *
 * The SOS screen told the patient to "call 112 or 108" in five places and gave
 * them no way to do it — while the same app has dialled pharmacies, imaging
 * centres and hospitals from a `tel:` link for months. A request raised here
 * waits for a fleet to accept; the state services do not, which is why this sits
 * above the SOS button rather than below it.
 *
 * `tel:` is the whole mechanism — no permission, no API, and it works on a
 * phone browser and in the installed app alike.
 */

const NUMBERS: { number: string; label: string }[] = [
  { number: '112', label: 'All emergencies' },
  { number: '108', label: 'Ambulance' },
];

function IconPhone({ size = 16, color = '#fff' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.81.36 1.6.65 2.36a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.76.29 1.55.52 2.36.65A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

export default function EmergencyCallStrip({ compact = false }: { compact?: boolean }) {
  return (
    <div
      style={{
        background: '#FEF2F2',
        border: '1px solid #FECACA',
        borderRadius: 16,
        padding: compact ? 12 : 14,
      }}
    >
      {!compact && (
        <div style={{ fontSize: 11, fontWeight: 700, color: '#991B1B', fontFamily: T.font, marginBottom: 8 }}>
          Life-threatening? Call now — do not wait for this app
        </div>
      )}
      <div style={{ display: 'flex', gap: 10 }}>
        {NUMBERS.map((n) => (
          <a
            key={n.number}
            href={`tel:${n.number}`}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              padding: '12px 10px',
              borderRadius: 12,
              background: '#DC2626',
              color: '#fff',
              textDecoration: 'none',
              fontFamily: T.font,
              fontWeight: 800,
              fontSize: 13,
              boxShadow: '0 4px 14px rgba(220,38,38,0.28)',
            }}
          >
            <IconPhone />
            <span>
              Call {n.number}
              <span style={{ display: 'block', fontSize: 9, fontWeight: 600, opacity: 0.9 }}>{n.label}</span>
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}
